import React from 'react'
import ContractsListContainer from './ContractsListContainer'

const ContractsList = props => (
  <ContractsListContainer {...props} data-test="component-contracts-list" />
)

export default ContractsList
